import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import "./OurVision.css";

const OurVision = () => {
  const navigate = useNavigate(); // Hook for navigation

  // Function to handle button click and redirect to /OurSchool
  const handleOurSchoolClick = () => {
    navigate("/OurSchool"); // Replace "/OurSchool" with your actual route
  };

  return (
    <section className="vision-section py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center mb-5">
            <h2 className="display-5 fw-bold mb-3">Our Vision for Education</h2>
            <p className="lead">
              We reimagine traditional classrooms, creating dynamic,
              student-centered environments where curiosity and creativity thrive.
            </p>
          </Col>
        </Row>
        <Row className="g-4">
          {/* Flexible Seating */}
          <Col lg={4} className="text-center">
            <div className="vision-card p-4">
              <div className="icon-wrapper mb-3">
                <i className="mdi mdi-seat-recline-extra fs-36 text-white"></i>
              </div>
              <h5 className="fw-bold">Flexible Seating</h5>
              <p>
                Our classrooms feature adaptable seating arrangements to encourage
                collaboration and comfort.
              </p>
            </div>
          </Col>

          {/* Interactive Technology */}
          <Col lg={4} className="text-center">
            <div className="vision-card p-4">
              <div className="icon-wrapper mb-3">
                <i className="mdi mdi-tablet-dashboard fs-36 text-white"></i>
              </div>
              <h5 className="fw-bold">Interactive Technology</h5>
              <p>
                State-of-the-art tools and devices to enhance engagement and
                learning outcomes.
              </p>
            </div>
          </Col>

          {/* Creative Learning */}
          <Col lg={4} className="text-center">
            <div className="vision-card p-4">
              <div className="icon-wrapper mb-3">
                <i className="mdi mdi-palette fs-36 text-white"></i>
              </div>
              <h5 className="fw-bold">Creative Learning</h5>
              <p>
                Montessori-inspired settings that foster curiosity, creativity,
                and joy in learning.
              </p>
            </div>
          </Col>
        </Row>

        {/* Button to redirect to /OurSchool */}
        <Row className="justify-content-center mt-5">
          <Col lg={6} className="text-center">
            <button className="our-school-button" onClick={handleOurSchoolClick}>
              Discover Our School
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OurVision;